import { type Module } from "vuex";
import type { DefaultApi } from "@/api";
import type { State as RootState } from "@/stores";

export interface State {}

export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async update(
      {},
      { firstName, lastName }: { firstName: string; lastName: string },
    ): Promise<void> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      await api.updateProfile({
        first_name: firstName,
        last_name: lastName,
      });
    },
  },
};
